// extracted by mini-css-extract-plugin
module.exports = {"root-item":"root-item___21I4D","has-sidebar":"has-sidebar___16MCt"};